import type { EmpleadoResumen, Periodo, PeriodoRango, VentaRow } from './types';

export const SIN_USUARIO = 'Usuario no identificado';

export function getPeriodoRango(p: Periodo, now: Date = new Date()): PeriodoRango {
  const fin = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  let inicio: Date;
  let label: string;

  switch (p) {
    case 'hoy':
      inicio = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
      label = 'Hoy';
      break;
    case 'semana': {
      const day = now.getDay();
      const diff = day === 0 ? 6 : day - 1;
      inicio = new Date(now.getFullYear(), now.getMonth(), now.getDate() - diff, 0, 0, 0, 0);
      label = 'Esta Semana';
      break;
    }
    case 'mes':
    default:
      inicio = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
      label = 'Este Mes';
      break;
  }

  return { inicio, fin, label };
}

export function filtrarPorRango(ventas: VentaRow[], rango: PeriodoRango): VentaRow[] {
  return ventas.filter((v) => {
    const d = new Date(v.fecha);
    return d >= rango.inicio && d <= rango.fin;
  });
}

export function agruparPorEmpleado(ventas: VentaRow[]): EmpleadoResumen[] {
  const map = new Map<string, EmpleadoResumen>();

  ventas.forEach((v) => {
    const key = v.usuario_id || 'sin-usuario';
    let entry = map.get(key);
    if (!entry) {
      entry = {
        key,
        nombre: v.usuario_nombre || SIN_USUARIO,
        usuario: v.usuario_login || '—',
        rol: v.usuario_rol || '—',
        cantidad: 0,
        total: 0,
        efectivo: 0,
        qr: 0,
      };
      map.set(key, entry);
    }
    const monto = Number(v.total) || 0;
    entry.cantidad += 1;
    entry.total += monto;
    if (v.metodo_pago === 'Efectivo') entry.efectivo += monto;
    else if (v.metodo_pago === 'QR') entry.qr += monto;
  });

  return Array.from(map.values()).sort((a, b) => b.total - a.total);
}

export function rolEtiqueta(rol: string): string {
  return rol === 'super_admin' ? 'Super Admin' : 'Usuario';
}

export function sanitizeNombre(s: string): string {
  const limpio = s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9_-]+/g, '_')
    .replace(/^_+|_+$/g, '');
  return limpio || 'usuario';
}

function partesFecha(fecha: Date): { y: string; m: string; d: string } {
  return {
    y: String(fecha.getFullYear()),
    m: String(fecha.getMonth() + 1).padStart(2, '0'),
    d: String(fecha.getDate()).padStart(2, '0'),
  };
}

export function nombreArchivoPeriodo(periodo: Periodo, fecha: Date): string {
  const { y, m, d } = partesFecha(fecha);
  if (periodo === 'hoy') return `Historial_Ventas_Hoy_${y}-${m}-${d}.pdf`;
  if (periodo === 'semana') return `Historial_Ventas_Semana_${y}-${m}-${d}.pdf`;
  return `Historial_Ventas_Mes_${y}-${m}.pdf`;
}

export function nombreArchivoEmpleado(usuario: string, periodo: Periodo): string {
  const tag = periodo === 'hoy' ? 'Hoy' : periodo === 'semana' ? 'Semana' : 'Mes';
  return `Historial_Ventas_${sanitizeNombre(usuario)}_${tag}.pdf`;
}